import { getUserPermissions, getUserInfo } from "@/api/login";

export const setToken = ({commit}, data) => {
  commit('setToken', data)
}

export const setUserInfo = ({commit}, data) => {
  commit('setUserInfo', data)
}

export const setRoleId = ({commit}, data) => {
  commit('setRoleId', data)
}

export const getUser = ({ commit }) => {
  return new Promise((resolve/* , reject */) => {
      getUserInfo().then(res => {
          if(res.code === 0){
              commit("setUserInfo", {...res.data,});
              resolve(true)
          }
      })
  })
}

export const setIsLogin = ({commit}, data) => {
  commit('setIsLogin', data)
}
